export default __webpack_public_path__ + "static/media/mediagal_pos2.a7e14b33.jpg";